(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3463],{

/***/ 96159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M2": function() { return /* binding */ isFragment; },
/* harmony export */   "Tm": function() { return /* binding */ cloneElement; }
/* harmony export */ });
/* unused harmony export replaceElement */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function isFragment(child) {
  return child && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && child.type === react__WEBPACK_IMPORTED_MODULE_0__.Fragment;
}
const replaceElement = (element, replacement, props) => {
  if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(element)) {
    return replacement;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function cloneElement(element, props) {
  return replaceElement(element, element, props);
}

/***/ }),

/***/ 98849:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/setup",
      function () {
        return __webpack_require__(7648);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getHomeRoute": function() { return /* binding */ getHomeRoute; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57381);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61906);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53399);
/* harmony import */ var src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32870);
/* harmony import */ var src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99518);
// ** React Imports




// ui





const getHomeRoute = (role)=>{
    if (role === "client") return "/acl";
    else if (localStorage.getItem("currentMode") === "Android-Cloud") return "/android/dashboard";
    else return "/dashboard";
};
/** 提到组件外，避免每次 render 换组件类型导致偶发挂载异常 */ const SelectPlatform = (param)=>{
    let { t , router  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-[24px] text-[#000] font-[Poppins] font-[600] leading-[36px] text-center mx-[15px] Mlg:mt-[60px] mt-[78px] mb-[37px]",
                children: t("Select the type of device want to monitoring")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[728px] grid grid-cols-1 smjs:grid-cols-2 gap-[30px] mx-[6px] smjs:mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px] [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]",
                        onClick: ()=>{
                            window.localStorage.setItem("currentMode", "iOS-Cloud");
                            router.push((0,src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_6__/* .appendSetupQuery */ .Rb)("/ios/setup"));
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "/images/bind/ios.svg",
                                alt: "ios",
                                width: 41,
                                height: 48,
                                className: "w-[41px] h-[48px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-center items-center mt-[9px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]",
                                        children: t("iOS")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/images/bind/arrow.svg",
                                        alt: "arrow",
                                        width: 6,
                                        height: 12,
                                        className: "w-[6.01px] h-[11.66px] ml-2"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px] [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]",
                        onClick: ()=>{
                            window.localStorage.setItem("currentMode", "Android-Cloud");
                            router.push((0,src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_6__/* .appendSetupQuery */ .Rb)("/android/classification"));
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "/images/bind/android.svg",
                                alt: "android",
                                width: 42,
                                height: 50,
                                className: "w-[42.31px] h-[50px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-center items-center mt-[9px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]",
                                        children: t("Android")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/images/bind/arrow.svg",
                                        alt: "arrow",
                                        width: 6,
                                        height: 12,
                                        className: "w-[6.01px] h-[11.66px] ml-2"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const Home = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [setupBlocked, setSetupBlocked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    // 选平台前确保 bind 上下文（单张未绑单自动带 orderId）
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const init = async ()=>{
            const guard = await (0,src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_6__/* .ensureBindOrderContext */ .Sj)(window.location.search);
            if (guard.blocked) {
                setSetupBlocked(true);
                return;
            }
            setSetupBlocked(false);
            if (guard.orderId) return;
            try {
                const result = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_5__.getNotBindOrder)();
                await (0,src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_7__/* .redirectIfShouldBuyPackage */ .og)(result);
            } catch (e) {
            // ignore — choose-device page still usable
            }
        };
        init();
    }, []);
    if (setupBlocked) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex min-h-[240px] items-center justify-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                size: "large"
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SelectPlatform, {
        t: t,
        router: router
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; }
/* harmony export */ });
/* unused harmony exports isSubscriptionActive, isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ isSelectableDevice; },
/* harmony export */   "MA": function() { return /* binding */ resolveDeviceSubscriptionStatus; },
/* harmony export */   "Mi": function() { return /* binding */ resolveInitialEntry; },
/* harmony export */   "Xz": function() { return /* binding */ getDeviceNotSelectableMessage; },
/* harmony export */   "cw": function() { return /* binding */ isGraceDevice; },
/* harmony export */   "dv": function() { return /* binding */ validateDeviceSelection; },
/* harmony export */   "mJ": function() { return /* binding */ isDeviceVisibleInSidebar; },
/* harmony export */   "oT": function() { return /* binding */ pickPreferredSelectableDevice; },
/* harmony export */   "q6": function() { return /* binding */ shouldEnterExpiredPurchasePage; },
/* harmony export */   "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
/* harmony export */   "w4": function() { return /* binding */ resolveDeviceOrderId; }
/* harmony export */ });
/* unused harmony exports normalizeSubscriptionStatus, resolveSubscriptionStatus, isSelectableSubscriptionStatus, isLapsedDevice, isNoneDevice, areAllDevicesLapsed, areAllDevicesNonSelectable */
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/** 设备订阅状态机（与后端 user-device.subscription_status 对齐） */ const SUBSCRIPTION_STATUS = Object.freeze({
    /** 未过期 */ ACTIVE: "active",
    /** 已过期且 ≤30 天（含第 30 天，宽限期，仍可选中） */ GRACE: "grace",
    /** 已过期且 >30 天（失效，禁止选中） */ LAPSED: "lapsed",
    /**
   * 特殊态：无已支付订单，或 expire_time 为空/异常。
   * ≠ lapsed：不进「全员超 30 天」独立续费页；也不可选中。
   */ NONE: "none"
});
const STATUS_SET = new Set(Object.values(SUBSCRIPTION_STATUS));
const normalizeSubscriptionStatus = (raw)=>{
    if (raw == null || raw === "") return null;
    const status = String(raw).toLowerCase();
    return STATUS_SET.has(status) ? status : null;
};
/**
 * 由 expire_time 本地兜底（接口未回 subscription_status 时用）。
 * 无有效 expire_time → active（兼容历史无到期字段仍可进 dashboard）。
 * 服务端显式 none 时走 subscription_status 字段，不走本函数。
 */ const resolveSubscriptionStatus = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(expireTime);
    if (!Number.isFinite(ms)) return SUBSCRIPTION_STATUS.ACTIVE;
    if (ms >= now) return SUBSCRIPTION_STATUS.ACTIVE;
    if (now - ms <= graceMs) return SUBSCRIPTION_STATUS.GRACE;
    return SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 优先用设备/DeviceUser 上的 subscription_status；否则用 expire_time 兜底。
 */ const resolveDeviceSubscriptionStatus = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const fromApi = normalizeSubscriptionStatus(device === null || device === void 0 ? void 0 : device.subscription_status);
    if (fromApi) return fromApi;
    var ref;
    return resolveSubscriptionStatus((ref = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .resolveDeviceExpireTime */ .ku)(device)) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
};
/** active / grace 可选中；lapsed / none 禁止成为当前选中 */ const isSelectableSubscriptionStatus = (status)=>status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.GRACE;
const isSelectableDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return isSelectableSubscriptionStatus(resolveDeviceSubscriptionStatus(device, now, graceMs));
};
const isLapsedDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.LAPSED;
};
const isGraceDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.GRACE;
};
const isNoneDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.NONE;
};
/**
 * 侧栏设备卡片是否展示：
 * - active / grace：展示
 * - none：展示（特殊：无有效已付单，但仍是绑定记录）
 * - lapsed：隐藏
 */ const isDeviceVisibleInSidebar = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) !== SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 设备关联已支付订单 ID（后端 user-device.order_id）。
 * @returns {string|number|null}
 */ const resolveDeviceOrderId = (device)=>{
    var ref, ref1;
    if (!device) return null;
    var _order_id, ref2, ref3;
    const id = (ref3 = (ref2 = (_order_id = device.order_id) !== null && _order_id !== void 0 ? _order_id : device.orderId) !== null && ref2 !== void 0 ? ref2 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id;
    if (id == null || id === "") return null;
    return id;
};
/**
 * 初始化/恢复选中：优先 active，其次 grace；永不返回 lapsed/none。
 * @param {Array} devices
 * @param {string} [platformType]
 */ const pickPreferredSelectableDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const selectable = scoped.filter((item)=>isSelectableDevice(item));
    if (!selectable.length) return null;
    const active = selectable.find((item)=>resolveDeviceSubscriptionStatus(item) === SUBSCRIPTION_STATUS.ACTIVE);
    return active || selectable[0] || null;
};
/**
 * 选中校验：仅 active/grace 可选。
 * @returns {{ ok: boolean, status: string, reason?: string }}
 */ const validateDeviceSelection = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!device || typeof device === "object" && !Object.keys(device).length) {
        return {
            ok: true,
            status: SUBSCRIPTION_STATUS.NONE
        };
    }
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (!isSelectableSubscriptionStatus(status)) {
        return {
            ok: false,
            status,
            reason: status === SUBSCRIPTION_STATUS.LAPSED ? "lapsed_device_not_selectable" : "device_not_selectable"
        };
    }
    return {
        ok: true,
        status
    };
};
/** 侧栏不可选设备的英文提示（none ≠ 过期） */ const getDeviceNotSelectableMessage = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (status === SUBSCRIPTION_STATUS.NONE) {
        return "This package has no active subscription and cannot be selected.";
    }
    if (status === SUBSCRIPTION_STATUS.LAPSED) {
        return "This package subscription has expired and cannot be selected.";
    }
    return "This package cannot be selected.";
};
/**
 * 是否「全部设备都是 lapsed」。
 * none 不算 lapsed（有 none 混在时为 false）。
 * 只信 subscription_status（无字段时才 expire_time 兜底）。
 */ const areAllDevicesLapsed = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>isLapsedDevice(device, now, graceMs));
};
/** 无任何可选中设备（全是 lapsed / none） */ const areAllDevicesNonSelectable = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>!isSelectableDevice(device, now, graceMs));
};
/**
 * 独立续费页入口（替换旧「全设备过期超 30 天 + 无未绑单」本地推算）：
 * - 设备非空且全部 subscription_status === lapsed
 * - 且 not-bind-order 无有效未绑单
 *
 * none 不进此页。
 */ const shouldEnterExpiredPurchasePage = function() {
    let { devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    return list.length > 0 && areAllDevicesLapsed(list) && unbound.length === 0;
};
/**
 * 登录/进站：active/grace 设备 > 未绑单 > 空态
 * 「全部过期超 30 天」的判定由 userEntryGate 负责（后端状态优先），这里不参与。
 * 永不选中 lapsed/none。
 * @returns {{ type: 'device'|'unbound'|'empty', device: object|null }}
 */ const resolveInitialEntry = function() {
    let { devices =[] , validUnboundOrders =[] , preferredMode =null , preferredDevice =null  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    if (preferredDevice && isSelectableDevice(preferredDevice)) {
        return {
            type: "device",
            device: preferredDevice
        };
    }
    const preferred = pickPreferredSelectableDevice(list, preferredMode) || pickPreferredSelectableDevice(list);
    if (preferred) {
        return {
            type: "device",
            device: preferred
        };
    }
    if (unbound.length > 0) {
        return {
            type: "unbound",
            device: null
        };
    }
    return {
        type: "empty",
        device: null
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,210,2870,9774,2888,179], function() { return __webpack_exec__(98849); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);